import { Card, CardContent } from "@/components/ui/card";
import { ShieldCheck, ShieldAlert, Activity } from "lucide-react";

export default function ValidationCard({ validation }) {
  if (!validation) return null;
  const isEngine = validation.is_engine;

  return (
    <Card className="border border-slate-200 shadow-none rounded-sm overflow-hidden" data-testid="validation-card">
      <div className="border-b border-slate-200 p-4 bg-slate-50/50 flex items-center gap-2">
        <Activity size={18} className="text-slate-500" />
        <span className="text-sm font-bold uppercase tracking-wider text-slate-600">Sound Validation</span>
      </div>
      <CardContent className="p-5">
        <div className="flex items-center gap-4 mb-4">
          <div className={`w-14 h-14 rounded-sm flex items-center justify-center ${isEngine ? 'bg-emerald-50' : 'bg-red-50'}`}>
            {isEngine ? <ShieldCheck size={28} className="text-emerald-500" /> : <ShieldAlert size={28} className="text-red-500" />}
          </div>
          <div>
            <p className={`text-lg font-bold ${isEngine ? 'text-emerald-700' : 'text-red-700'}`}>
              {isEngine ? "Engine Sound Verified" : "Unverified Sound"}
            </p>
            <p className="text-base text-slate-500 mt-1">
              {validation.confidence}% confidence level
            </p>
          </div>
        </div>

        <p className="text-base text-slate-600 leading-relaxed">{validation.reason}</p>

        {validation.features && (
          <div className="mt-4 pt-4 border-t border-slate-100 space-y-2">
            <div className="flex justify-between text-sm">
              <span className="text-slate-500">Spectral Centroid</span>
              <span className="font-mono text-slate-700 font-medium">{validation.features.spectral_centroid?.toFixed(0)} Hz</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-slate-500">RMS Energy</span>
              <span className="font-mono text-slate-700 font-medium">{validation.features.rms_energy?.toFixed(4)}</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-slate-500">Est. RPM</span>
              <span className="font-mono text-slate-700 font-medium">{validation.features.estimated_rpm?.toFixed(0)}</span>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
